module.exports = __webpack_public_path__ + "static/media/Fantasy_main.5c1001e9.jpg";